import { render, staticRenderFns } from "./MetaTab.vue?vue&type=template&id=b9dedee6&"
import script from "./MetaTab.vue?vue&type=script&lang=js&"
export * from "./MetaTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports